// @ts-nocheck
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Construction } from 'lucide-react';

interface Props {
  title: string;
  description: string;
  /** Optional list of planned sub-sections shown as muted pills. */
  sections?: string[];
}

/**
 * Simple centered "Coming soon" placeholder for demo-only sidebar entries.
 * No data, no logic — just communicates the planned scope.
 */
const ComingSoonPage: React.FC<Props> = ({ title, description, sections }) => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center opacity-90">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Construction className="h-7 w-7" />
      </div>
      <div className="mb-2 flex items-center gap-2">
        <h1 className="text-2xl font-bold text-muted-foreground">{title}</h1>
        <Badge variant="secondary" className="uppercase tracking-wide">
          Coming soon
        </Badge>
      </div>
      <p className="max-w-md text-sm text-muted-foreground">{description}</p>

      {sections && sections.length > 0 && (
        <div className="mt-6 flex max-w-lg flex-wrap justify-center gap-2">
          {sections.map((s) => (
            <span
              key={s}
              className="rounded-full border border-dashed px-3 py-1 text-xs text-muted-foreground"
            >
              {s}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ComingSoonPage;
